import { seriesService } from 'content/service';
import { SeriesInterface } from 'content/type/seriesType';
import { peopleApiService } from 'service/api/peopleApiService';
import { PeopleInterface } from 'type/peopleType';

interface SeriesEditHandlers {
  fetchedSeries: SeriesInterface | undefined;
  fetchedPeople: PeopleInterface[];
}

export const fetchSeries = async (id: number): Promise<SeriesInterface | undefined> => {
  return await seriesService.fetchById(id);
};

export const fetchPeople = async (): Promise<PeopleInterface[]> => {
  const people = await peopleApiService.fetch();
  return people.results;
};

export const SeriesEditHandlers = async (id: number): Promise<SeriesEditHandlers> => {
  const fetchedSeries = await fetchSeries(id);
  const fetchedPeople = await fetchPeople();

  return {
    fetchedSeries: fetchedSeries,
    fetchedPeople,
  };
};
